/**
 * Configuración de plataforma del cliente.
 *
 * Centraliza valores que estaban hardcodeados dispersos. El dominio de la
 * plataforma idealmente vendría del backend (clientes.app.operativa / un endpoint de
 * config) para que el mismo build sirva a otra instancia de aarpia-lite sin
 * recompilar — deuda de molde anotada en AC5. Por ahora, una sola fuente local.
 */
export const PLATFORM_DOMAIN = 'aarpia-lite.es'

/** Host de la plataforma (el Arquitecto, herramienta del operador). */
export const HOST_ARQUITECTO = 'arquitecto.aarpia-lite.es'

/**
 * ¿Este front se sirve como CLIENTE (no como el Arquitecto)? PWA-3: en hosts de
 * cliente la superficie primaria es el chat-agente y la PWA es instalable; en el
 * Arquitecto la home es el dashboard y no se instala. Derivado del host (cero
 * hardcode de cliente concreto). En dev/localhost → false (se trabaja como Arquitecto).
 */
export function esHostCliente(): boolean {
  if (typeof window === 'undefined') return false
  const h = window.location.hostname
  return h !== HOST_ARQUITECTO && !h.startsWith('localhost') && !/^\d+\./.test(h)
}

/**
 * Slug de ESTA app (FRONT-CUTOVER-BRANDING 1d4c8dad): identidad del contenedor
 * AARPIA.clientes.app.operativa que gobierna este front. Derivado del hostname
 * (arquitecto.aarpia-lite.es → "arquitecto"), con fallback para dev/localhost.
 * Es derivación, no hardcoding: el mismo build sirve a otra app bajo su DNS.
 */
export function slugApp(): string {
  if (typeof window !== 'undefined') {
    const h = window.location.hostname
    if (h && h.includes('.') && !h.startsWith('localhost') && !/^\d+\./.test(h)) {
      return h.split('.')[0]
    }
  }
  return 'arquitecto'
}

/**
 * GATE CUD-6 (orden CONECTOR-UNIVERSAL-DEMO 046a2c62): mientras sea true, los
 * flujos que INSTANCIAN (alta de app) quedan bloqueados — hay una purga de
 * tenant en vuelo y crear instancias regeneraría drift. Lo levanta el auditor
 * al confirmar VOE-PURA-OK durable (entonces C2 = solo instanciar lo construido).
 */
export const GATE_SOLO_LECTURA = false // levantado: VOE-PURA-OK durable confirmado por el auditor (GO C2, 2026-06-05)

/** Validación de formato (no de negocio; el backend revalida server-side). */
export const RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
/** DNI/NIE/CIF español, formato laxo (no comprueba el dígito de control). */
export const RE_NIF = /^[A-Za-z]?\d{7,8}[A-Za-z0-9]$/
export const PASSWORD_MIN = 8

export const esEmailValido = (v: string) => RE_EMAIL.test(v.trim())
export const esNifValido = (v: string) => RE_NIF.test(v.trim())
